@if (!product.variantOptions) {
  @if (unitPrice) {
    <div class="boels-product-price-container">
      <span class="boels-product-price-intro">{{
        'productDetails.labelFrom' | transloco
      }}</span>
      <p class="boels-product-price-total">
        <span class="boels-product-price">{{ unitPrice.formattedValue }}</span>
        {{ unitPrice.unitName }} {{ label | transloco }}
      </p>
    </div>
  }
  <div>
    @if (!product.unitPrices?.length) {
      <p class="boels-product-price-label">
        {{ 'productDetails.labelPriceOnApplication' | transloco }}
      </p>
    }
  </div>
}
